import { gql } from '@apollo/client'

export const CHANGE_LOCALE = gql`
  mutation ChangeLocale($employeeId: HashedId!, $locale: String!) {
    changeLocale(employeeId: $employeeId, locale: $locale)
  }
`

export const CHANGE_TIMEZONE = gql`
  mutation ChangeTimezone($employeeId: HashedId!, $timezone: String!) {
    changeTimezone(employeeId: $employeeId, timezone: $timezone)
  }
`

export const CHANGE_NAME_DISPLAY_PREFERENCE = gql`
  mutation ChangeNameDisplayPreference($employeeId: HashedId!, $nameDisplayPreference: String!) {
    changeNameDisplayPreference(employeeId: $employeeId, nameDisplayPreference: $nameDisplayPreference)
  }
`
